

(function ($) {
    'use strict';
    $(function () {


        $('.js-program-table-swiper').each((i, element) => {
            const id = $(element).prop('id');

            const program = new Swiper('#' + id, {
                slidesPerView: 'auto',
                pagination: {
                    el: '#' + id + "-pagination",
                    clickable: true
                },
                navigation: {
                    prevEl: ".js-swiper-prev-" + i,
                    nextEl: ".js-swiper-next-" + i,
                }

            });

        })

    });
})(jQuery);
